export interface CategoryFlat {
    id: number;
    name: string;
    slug: string;
    parent_id: number | null;
    is_b2b_only?: boolean;
    position?: number;
}

export interface CategoryNode extends CategoryFlat {
    children: CategoryNode[];
}

export interface CategoryTreeOption extends CategoryFlat {
    depth: number;
}

export function buildCategoryPathLabel(cat: CategoryFlat, allCategories: CategoryFlat[]): string {
    const parts: string[] = [cat.name];
    let current: CategoryFlat = cat;
    while (current.parent_id !== null) {
        const parent = allCategories.find(c => c.id === current.parent_id);
        if (!parent) break;
        parts.unshift(parent.name);
        current = parent;
    }
    return parts.join(' > ');
}

export function buildCategoryTree(flat: CategoryFlat[]): CategoryNode[] {
    const map: Record<number, CategoryNode> = {};
    const roots: CategoryNode[] = [];

    flat.forEach(c => {
        map[c.id] = { ...c, children: [] };
    });

    flat.forEach(c => {
        if (c.parent_id !== null && map[c.parent_id]) {
            map[c.parent_id].children.push(map[c.id]);
        } else {
            roots.push(map[c.id]);
        }
    });

    return roots;
}

export function sortCategoriesHierarchically(flat: CategoryFlat[]): CategoryTreeOption[] {
    const tree = buildCategoryTree(flat);
    const result: CategoryTreeOption[] = [];

    function traverse(node: CategoryNode, depth: number) {
        const { children, ...flatNode } = node;
        result.push({ ...flatNode, depth });
        
        // Sort children by position
        const sortedChildren = [...node.children].sort((a, b) => (a.position ?? 0) - (b.position ?? 0));
        sortedChildren.forEach(child => traverse(child, depth + 1));
    }

    // Sort root nodes by position
    const sortedRoots = [...tree].sort((a, b) => (a.position ?? 0) - (b.position ?? 0));
    sortedRoots.forEach(root => traverse(root, 0));

    return result;
}

